import styled from 'styled-components';
import { shadow } from './theme';

export const WhiteBlock = styled.div`
  background-color: #fff;
  box-shadow: ${shadow.shadow};
  border-radius: 8px;
  border: 1px solid #ebebeb;

  &.equal-height {
    min-height: 100%;
  }

  .white-block-head {
    padding: 22px 35px;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    border-bottom: 1px solid #e5e5e5;
    margin: 0;
  }
  .white-block-body {
    padding: 22px 35px;
  }
  .white-block-body-small {
    padding: 15px;
  }
`;
